import { BaseService } from '@/core/base-service';
import { ITemplateType } from '@/models/template-type.model';

export default class TemplateTypeService extends BaseService<ITemplateType> {
  public constructor() {
    super('services/servicescard/api/template-type');
  }
}
